import request from "./requestApi";
import Vue from "vue";

// 挂载全局
Vue.prototype.$request = request; // 请求api集合
